const $ = jQuery.noConflict();
import smoothScroll from '../__utils/smoothScroll';

class Accordions {
	constructor( trigger ) {
		this.trigger = $( trigger );
		this.collapse = $( '.js-collapse-accordions' );
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.trigger.on( 'click', this.toggleAccordion );
	}
	toggleAccordion() {
		const isClosed = $( this ).parents( '.accordion-wrapper' ).data( 'close' );

		if (
			isClosed === 'close' &&
			! $( this ).parent().hasClass( 'active' ) &&
			! $( this ).parent().hasClass( 'bellow--nested' )
		) {
			$( this )
				.parents( '.accordion-wrapper' )
				.find( '.bellow.active .bellow__content' )
				.first()
				.stop()
				.slideToggle( 250 );
			$( this )
				.parents( '.accordion-wrapper' )
				.find( '.bellow.active' )
				.first()
				.toggleClass( 'active' );
		}
		$( this ).parent().toggleClass( 'active' );
		if ( $( this ).parent().hasClass( 'active' ) && 'scroll' === $( this ).parents( '.accordion-wrapper' ).data( 'scroll' ) ) {
			$( this ).parent().addClass( 'accordion-scroll' );
			// eslint-disable-next-line no-var
			var $this = $( this );
			setTimeout( () => {
				smoothScroll();
			}, 250 );
			setTimeout( () => {
				$this.parent().removeClass( 'accordion-scroll' );
			}, 750 );
		}

		$( this ).next().stop().slideToggle( 250 );
	}
}

export default new Accordions( '.bellow__title' );
